// user
export const SET_TOKEN = 'SET_TOKEN';
export const SET_TENANT = 'SET_TENANT';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_USER_ID = 'SET_USER_ID';

export const SET_TOKEN_COOKIES = 'SET_TOKEN_COOKIES';
export const SET_TENANT_COOKIES = 'SET_TENANT_COOKIES';
export const SET_ACCOUNT_COOKIES = 'SET_ACCOUNT_COOKIES';
export const SET_USER_ID_COOKIES = 'SET_USER_ID_COOKIES';

export const USER_SET_TOKEN = `user/${SET_TOKEN}`;
export const USER_SET_TENANT = `user/${SET_TENANT}`;
export const USER_SET_ACCOUNT = `user/${SET_ACCOUNT}`;
export const SET_TENANT_PAY = 'SET_TENANT_PAY';

export const SET_FIRST_LOGIN = 'SET_FIRST_LOGIN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_OPTIONS = 'SET_USER_OPTIONS';
export const SET_ACTIVE_USER_OPTIONS = 'SET_ACTIVE_USER_OPTIONS';
export const SET_USER_MENUS = 'SET_USER_MENUS';
export const SET_USER_RESOURCES = 'SET_USER_RESOURCES';
export const SET_CHECKED_USER_STATE = 'SET_CHECKED_USER_STATE';
export const USER_SET_CHECKED_USER_STATE = `user/${SET_CHECKED_USER_STATE}`;
export const USER_SET_USER_INFO = `user/${SET_USER_INFO}`;
export const USER_SET_FIRST_LOGIN = `user/${SET_FIRST_LOGIN}`;
// 消息
export const SET_MESSAGE = 'SET_MESSAGE';
export const USER_SET_MESSAGE = `user/${SET_MESSAGE}`;
export const SET_STATUS = 'SET_STATUS';
export const USER_SET_STATUS = `user/${SET_STATUS}`;

// 是否开启轮询
export const SET_POLLING = 'SET_POLLING'
export const USER_SET_POLLING = `user/${SET_POLLING}`

// 是否有全局消息提醒
export const SET_ISMSGSGLOBAL = 'SET_ISMSGSGLOBAL'
export const USER_SET_ISMSGSGLOBAL = `user/${SET_ISMSGSGLOBAL}`

// 是否点击我知道了， 点击我知道了并且页面停留在运营消息页面
export const SET_KNOW = 'SET_KNOW'
export const USER_SET_KNOW = `user/${SET_KNOW}`

// common
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_MARKETS = 'SET_MARKETS'
export const SET_ADMARKETS = 'SET_ADMARKETS'
export const SET_KEEP_ALIVE_VIEWS = 'SET_KEEP_ALIVE_VIEWS'
export const SET_NAV_MENU_TABS = 'SET_NAV_MENU_TABS'

export const CLOSE_NAV_ACTIVE_TABS = 'CLOSE_NAV_ACTIVE_TABS'

export const SET_COMPANY_INFO = 'user/SET_COMPANY_INFO'
export const GET_COMPANY_INFO = 'user/GET_COMPANY_INFO'


//新手任务
export const SET_USER_GUIDE_TASK_DATA = 'SET_USER_GUIDE_TASK_DATA'
export const GET_USER_GUIDE_TASK_DATA = 'GET_USER_GUIDE_TASK_DATA'
export const SET_USER_GUIDE_TASK_ITEM = 'SET_USER_GUIDE_TASK_ITEM'

export const SET_USER_GUIDE_STATE = 'SET_USER_GUIDE_STATE'
export const SET_USER_GUIDE_MENU_PATH = 'SET_USER_GUIDE_MENU_PATH'
export const SET_IS_NEW_USER_TASK = 'SET_IS_NEW_USER_TASK'
export const SET_GUIDE_VISIBLE = 'SET_GUIDE_VISIBLE'
export const SET_IS_SHOW_NOVICE_GUIDE = 'SET_IS_SHOW_NOVICE_GUIDE'

// 供应商
export const SET_SUPPLIER = 'SET_SUPPLIER_STATE'
export const PURCHASE_SET_SUPPLIER = 'purchase/SET_SUPPLIER_STATE'

export const SET_ACTIVE_SUPPLIER = 'SET_ACTIVE_SUPPLIER'
export const PURCHASE_SET_ACTIVE_SUPPLIER = 'purchase/SET_ACTIVE_SUPPLIER'

// 物流商
export const SET_LOGISTICS_OPTIONS = 'SET_LOGISTICS_OPTIONS'
export const LOGISTICS_SET_LOGISTICS_OPTIONS = 'logistics/SET_LOGISTICS_OPTIONS'

export const SET_ACTIVE_LOGISTICS_OPTIONS = 'SET_ACTIVE_LOGISTICS_OPTIONS'
export const LOGISTICS_SET_ACTIVE_LOGISTICS_OPTIONS = 'logistics/SET_ACTIVE_LOGISTICS_OPTIONS'

export const SET_OPEN_IMPORT = `statistics/OPEN_IMPORT`

export const SET_MARKET_AUTH_TYPE = 'user/SET_MARKET_AUTH_TYPE'

export const SET_LATEST_VERSION_ID = 'SET_LATEST_VERSION_ID'
export const USER_SET_LATEST_VERSION_ID = 'user/SET_LATEST_VERSION_ID'

export const SET_TIMEZONE_ID = 'SET_TIMEZONE_ID'
export const DASHBOARD_SET_TIMEZONE_ID = `dashboard/${SET_TIMEZONE_ID}`

export const SET_TIMEZONE_TEXT = 'SET_TIMEZONE_TEXT'
export const DASHBOARD_SET_TIMEZONE_TEXT = `dashboard/${SET_TIMEZONE_TEXT}`

export const SET_CURRENCY = 'SET_CURRENCY'
export const DASHBOARD_SET_CURRENCY = `dashboard/${SET_CURRENCY}`

export const SET_COUNTRY_MARKET = 'SET_COUNTRY_MARKET'
export const DASHBOARD_SET_COUNTRY_MARKET = `dashboard/${SET_COUNTRY_MARKET}`


